import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/baixa-venda";

export const Route = createFileRoute("/_authenticated/baixa-venda")({
  head: () => ({
    meta: [
      { title: "Baixa por venda — Milky Moo Palmares" },
      {
        name: "description",
        content: "Veja as baixas de insumos geradas pelas vendas registradas.",
      },
      { property: "og:title", content: "Baixa por venda — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Veja as baixas de insumos geradas pelas vendas registradas.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
